import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class ParametroInteger {
  static getByNombre (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `parametro_integer?r={"clave":{"nombre":"${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static updateByNombre (nombre, value) {
    const axios = getAxiosInstance()
    const promise = axios.put(`parametro_integer`,
      `{"valores": {"valor": "${value}"}, "clave": {"nombre": "${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default ParametroInteger
